import { css } from "@styled-system/css";

export const inputFieldClass = css({
	mb: "4",
});
